import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import DropZone from "./DropZone";
import { XIcon } from "@heroicons/react/solid";

class Uploader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
        };
    }

    isShowModal = (status) => {
        this.handleClose();
        this.setState({ showModal: status });
    };

    handleClose = () => {
        this.props.onPopupClose(false);
    };

    render() {
        return (
            <div
                style={{ display: this.props.showModalPopup ? "flex" : "none" }}
                className="bulk_upload"
            >
                <div className="uploadContain">
                    <Modal.Header className="model_header">
                        <h2>Upload Item EXCEL</h2>
                        <XIcon className="closeicon" onClick={this.handleClose} />
                    </Modal.Header>
                    <div className="uploadContain2">
                        <Modal.Body>
                            <DropZone />
                        </Modal.Body>
                    </div>
                </div>
            </div>
        );
    }
}

export default Uploader;
